import axios from "axios";
import { useMemo } from "react";
import config from "../config";

// ---------- localStorage safe helpers ----------
const safeJSONParse = (value, fallback = null) => {
  try {
    if (!value || value === "undefined" || value === "null") return fallback;
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};

const safeGetItem = (key) => {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    console.warn(`localStorage.getItem failed for key="${key}"`, e);
    return null;
  }
};

const safeSetJSON = (key, obj) => {
  try {
    localStorage.setItem(key, JSON.stringify(obj));
    return true;
  } catch (e) {
    console.warn(`localStorage.setItem(JSON) failed for key="${key}"`, e);
    return false;
  }
};

export function useGuideData() {
  // read user ONCE safely
  const userData = useMemo(
    () => safeJSONParse(safeGetItem("user"), null), // ✅ Safe nested call
    []
  );

  async function updateUserGuide(step) {
    if (!userData) return; // not logged in, nothing to update

    const existingGuide = Array.isArray(userData?.onBoarding?.guide)
      ? userData.onBoarding.guide
      : [];

    // avoid duplicates
    if (existingGuide.includes(step)) return;

    const guide = [...existingGuide, step];

    const doc = {
      onBoarding: {
        ...userData?.onBoarding,
        guide,
      },
    };

    const accessToken = safeGetItem("access_token"); // ✅ Safe access

    try {
      const { data } = await axios.patch(
        `${config.USERS}/users`,
        {},
        {
          headers: {
            token: accessToken,
            doc: encodeURIComponent(JSON.stringify(doc)),
          },
        }
      );

      // only update local user for non-regular users (your original logic)
      if (userData.role !== "user" && data?.value) {
        safeSetJSON("user", data.value); // ✅ Safe write
      }
    } catch (err) {
      console.error("Guide update failed:", err);
    }
  }

  const runJoyRideStep = (step) => {
    const freshUser = safeJSONParse(safeGetItem("user"), null); // ✅ Safe nested call
    return freshUser?.onBoarding?.guide?.includes(step) || false;
  };

  return {
    updateUserGuide,
    runJoyRideStep,
  };
}

export default useGuideData;